import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { CrudRows } from "../../../common/types";
import { ShowFilesCompact } from "../../../common/controls";
import { IMenuAction } from "../../../../common/controls";
import { FormControl } from "@mui/material";

export type UserAttachmentEditionViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  nameValue?: { displayId: string; id: string } | null;
  name: string;
  fileFiles: CrudRows;
  fileViewAction?: IMenuAction[];
  notesValue?: { displayId: string; id: string } | null;
  notes: string;
};

export const UserAttachmentEditionViewForm: React.FC<UserAttachmentEditionViewFormProps> =
  observer(
    ({
      onPrint = () => {},
      onCancel = () => {},
      onEdit,
      showToolbox = true,
      name = "",
      fileFiles,
      fileViewAction,
      notes = "",
    }) => {
      const rootStore = useRootStore();
      const { langStore } = rootStore;

      const componentRef = useRef(null);
      const handlePrint = useReactToPrint({
        content: () => componentRef.current,
      });

      return (
        <Grid>
          {showToolbox && (
            <FormToolbox
              editForm={onEdit}
              printForm={() => onPrint(handlePrint)}
              closeForm={() => onCancel()}
            />
          )}
          <Box ref={componentRef}>
            <GroupContainer
              id="null"
              title={langStore.groupUserAttachmentEditionLabel}
              collapsible={false}
            >
              <FormControl fullWidth>
                <ShowMultiLine
                  value={name}
                  label={langStore.UserAttachmentEditionNameLabel}
                />
                <ShowFilesCompact
                  rows={fileFiles}
                  showLabel={true}
                  label={langStore.UserAttachmentEditionFileLabel}
                  menuActions={fileViewAction}
                  columns={[
                    { name: "mimetype", title: langStore.fileTypeLabel },
                    { name: "name", title: langStore.fileNameLabel },
                    { name: "formattedSize", title: langStore.fileSizeLabel },
                  ]}
                />
                <ShowMultiLine
                  value={notes}
                  label={langStore.UserAttachmentEditionNotesLabel}
                />
              </FormControl>
            </GroupContainer>
          </Box>
        </Grid>
      );
    }
  );
